// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2im99","range":"MonthRangeSwitch_range__3J1ua","disabled":"MonthRangeSwitch_disabled__1DTm-"};